import { EventOccurrence } from "./EventOccurrence";

export interface RecurrenceDate {
  id: string;
  occurrences_future: EventOccurrence[];
  occurrences_past: EventOccurrence[];
  summary: string;
}
